import {createSlice,createAsyncThunk} from '@reduxjs/toolkit';
import { projectList } from '../../services/projectService';
export const fetchProjectDetails = createAsyncThunk('project/getProjectDetails',
    
    async(id,{rejectWithValue})=>{
        try{
            const result = await projectList(id);
            return  result;           
        }
        catch(error){
            return rejectWithValue({
                status: error.state,
                message: error?.message || "Something went wrong at Server Side"
            })
        }
    }
);

const initialState = {
    projectData: null,
    loadingFlag: false,
    error: null,
    noAccess: false,
    errorCode: null,
};

const projectListSlice = createSlice({
    name:'projectList',
    initialState,
    reducers:{
        clearProjectData:(state)=>{
            state.projectData = null;
            state.loadingFlag = false;
            state.error = null;
            state.noAccess = false;
            state.errorCode = null;
        },
        setProjectData:(state,action)=>{
            if(action?.payload){
                // TODO:store the data locally
                // const project = action?.payload;
            }
        },
        updateAccessStatus:(state,action)=>{
            state.noAccess = action.payload.noAccess;
            state.errorCode = action.payload.errorCode;
        },
    },
    extraReducers: (builder) => {
        builder
          .addCase(fetchProjectDetails.pending, (state) => {
            state.loadingFlag = true;
            state.error = null;
            state.noAccess = false;
          })
          .addCase(fetchProjectDetails.fulfilled, (state, action) => {
            state.loadingFlag = false;
            state.projectData = action.payload ;
            state.error = null;
            state.noAccess = false;
          })
          .addCase(fetchProjectDetails.rejected, (state, action) => {
            state.loadingFlag = false;
            state.error = action.payload || { message: 'An unknown error occurred' };
          });
    },
});

export const {clearProjectData, updateAccessStatus, setProjectData} = projectListSlice.actions;
export default projectListSlice.reducer;
